<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group id="group-visionname" label-for="input-visionname">
          <template v-slot:label>
            Name of Vison
            <span class="text-danger">*</span>
          </template>

          <b-form-input
            id="input-visionname"
            v-model="form.visionname"
            type="text"
            placeholder="Enter Vision"
            :state="$v.form.visionname.$dirty ? !$v.form.visionname.$error : null"
          ></b-form-input>

          <b-form-text id="input-visionname-help">
            Visionname only allows alphanumeric, underscore and dashboard between 3 and 15 characters. i.e.
            samplevisionname
          </b-form-text>

          <b-form-invalid-feedback id="input-visionname-invalid"
            >Please enter valid visionname.</b-form-invalid-feedback
          >
        </b-form-group>

        <!--b-form-group id="group-score" label-for="input-score">
          <template v-slot:label>
            Score
            <span class="text-danger">*</span>
          </template>

          <b-form-input
            id="input-score"
            type="text"
            v-model="form.score"
            :state="$v.form.score.$dirty ? !$v.form.score.$error : null"
            placeholder="Enter score"
          ></b-form-input>

          <b-form-invalid-feedback id="input-score-invalid">Please enter score.</b-form-invalid-feedback>
        </b-form-group-->

        <b-form-group id="group-state" label-for="input-state">
          <template v-slot:label>
            State
            <span class="text-danger">*</span>
          </template>

          <b-form-select
            id="input-state"
            v-model="form.state"
            :options="visionState"
            :state="$v.form.state.$dirty ? !$v.form.state.$error : null"
          ></b-form-select>

          <b-form-text id="input-state-help"
            >State field is configuring whether the user is active or deleted.</b-form-text
          >

          <b-form-invalid-feedback id="input-state-invalid">Please select valid state.</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="group-enabled" label-for="input-enabled">
          <template v-slot:label>
            Status
            <span class="text-danger">*</span>
          </template>

          <b-form-select
            id="input-enabled"
            v-model="form.status"
            :options="visionStatus"
            :state="$v.form.status.$dirty ? !$v.form.status.$error : null"
          ></b-form-select>

          <b-form-text id="input-enabled-help"
            >Status field is configuring whether the user is active or deleted.</b-form-text
          >

          <b-form-invalid-feedback id="input-enabled-invalid">Please select valid status.</b-form-invalid-feedback>
        </b-form-group>

        <template v-if="errorMessages">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ errorMessages }}</b-col>
          </b-row>
        </template>

        <b-row>
          <b-col>
            <b-button type="submit" size="sm" variant="success" :disabled="loading">
              <span class="spinner spinner-white" v-if="loading"></span>
              <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button size="sm" variant="warning" :to="{ path: `${listUrl}` }">
              <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';
import _ from 'lodash';
// import moment from 'moment';
import User from '@/model/user';
import Vision from '@/model/vision';
// import utils from '@/helper/utils';
import configService from '@/services/configService';

export default {
  name: 'VisionFormBox',
  props: {
    listUrl: String,
    visionType: String,
    formType: String,
    visionId: {
      type: Number,
      required: false
    },
    permissions: {
      type: Array,
      required: false
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      title: '',
      formLoaded: false,
      form: {
        visionname: null,
        score: null,
        thresholdNegative: null,
        thresholdNeutral: null,
        thresholdPositive: null,
        permissions: [],
        state: null,
        status: null
      },
      dateTimeFormat: configService.get('format').pickerDateTime,
      staffRoles: _.reduce(
        _.pick(User.userRole, ['administrator', 'staff']),
        (result, value, key) => {
          result.push({ value, text: _.capitalize(key) });
          return result;
        },
        []
      ),
      visionState: _.reduce(
        Vision.visionState,
        (result, value, key) => {
          result.push({ value, text: _.capitalize(key) });
          return result;
        },
        []
      ),
      visionStatus: _.reduce(
        Vision.visionStatus,
        (result, value, key) => {
          result.push({ value, text: _.capitalize(key) });
          return result;
        },
        []
      )
    };
  },
  validations() {
    const formValidation = {
      visionname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(15),
        validateVisionname: visionname => {
          if (visionname === null) {
            return false;
          }
          return visionname.match(/^[0-9a-zA-Z_]+$/) !== null;
        }
      },
      permissions: {},
      state: {
        validateState: value => {
          return _.some(Vision.visionState, state => value === state);
        }
      },
      status: {
        validateStatus: value => {
          return _.some(Vision.visionStatus, status => value === status);
        }
      }
    };

    return { form: formValidation };
  },
  mounted() {
    this.$nextTick(async () => {
      // Code that will run only after the entire view has been re-rendered
      if (this.formType === 'new') {
        this.form.status = Vision.visionStatus.active;
        this.form.status = Vision.visionState.neutral;
        this.formLoaded = true;

        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new vision' : 'Update vision';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('user', ['loading', 'user'])
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const vision = {
        visionname: this.form.visionname,
        score: this.form.score,
        permissions: _.reduce(
          this.form.permissions,
          (acc, permissionStatus, key) => {
            if (permissionStatus) {
              acc.push(this.permissions[key].id);
            }
            return acc;
          },
          []
        ),
        status: this.form.status
      };

      if (this.formType === 'new') {
        this.$emit('add', { vision });
      } else {
        this.$emit('edit', { vision });
      }
      return false;
    },
    setFormPermissions() {
      if (this.formLoaded) {
        if (this.formType === 'new') {
          _.forEach(this.permissions, (permission, index) => {
            this.form.permissions[index] = true;
          });
        } else {
          _.forEach(this.permissions, (permission, index) => {
            this.form.permissions[index] =
              _.isEmpty(_.find(this.user.permissions, userPermission => userPermission.id === permission.id)) === false;
          });
        }
      }
    }
  },
  watch: {
    vision(_newValue, _oldValue) {
      if (!this.vision.id) {
        return;
      }
      // Loaded user, assign to form

      this.form.visionname = this.vision.visionname;
      this.form.score = this.vision.score;
      this.form.status = this.vision.status;

      this.formLoaded = true;
      this.setFormPermissions();

      this.$v.$touch(); // Set initial validation
      this.$v.$reset(); // Reset $dirty
    },
    permissions(_newValue, _oldValue) {
      this.setFormPermissions();
    }
  }
};
</script>
